var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2295 1.28186L17.7714 12.4953C17.9154 12.83 17.9784 13.1022 17.9964 13.3849C18.0324 14.0455 17.7984 14.6876 17.3395 15.1817C16.8806 15.6741 16.2597 15.9648 15.5848 16H2.41101C2.13206 15.9833 1.85311 15.9207 1.59215 15.8238C0.287371 15.3042 -0.342523 13.842 0.188388 12.5746L6.77528 1.27393C7.00024 0.876691 7.34218 0.534061 7.76511 0.313861C8.9889 -0.356426 10.5456 0.0839728 11.2295 1.28186ZM9.78077 8.67175C9.78077 9.09454 9.42983 9.44774 8.9979 9.44774C8.56598 9.44774 8.20604 9.09454 8.20604 8.67175V6.17998C8.20604 5.75631 8.56598 5.41368 8.9979 5.41368C9.42983 5.41368 9.78077 5.75631 9.78077 6.17998V8.67175ZM8.9979 12.4601C8.56598 12.4601 8.20604 12.1069 8.20604 11.685C8.20604 11.2613 8.56598 10.909 8.9979 10.909C9.42983 10.909 9.78077 11.2534 9.78077 11.6753C9.78077 12.1069 9.42983 12.4601 8.9979 12.4601Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.d020388f6414a7ff52ddd54750de2902.svg";
export { ForwardRef as ReactComponent };